import { StatsigApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useStatsigAPI(): StatsigApi {
  return new StatsigApi(apiConfig);
}
